import { render, staticRenderFns } from "./product-endorsments.vue?vue&type=template&id=6fc25700&scoped=true&"
import script from "./product-endorsments.vue?vue&type=script&lang=js&"
export * from "./product-endorsments.vue?vue&type=script&lang=js&"
import style0 from "./product-endorsments.vue?vue&type=style&index=0&id=6fc25700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc25700",
  null
  
)

export default component.exports